import {BagSvg} from './BagSvg';
import {UserSvg} from './UserSvg';
import {GiftSvg} from './GiftSvg';
import {CopySvg} from './CopySvg';
import {MailSvg} from './MailSvg';
import {HeartSvg} from './HeartSvg';
import {CheckSvg} from './CheckSvg';
import {EyeOffSvg} from './EyeOffSvg';
import {GoBackSvg} from './GoBackSvg';
import {SearchSvg} from './SearchSvg';
import {DeleteSvg} from './DeleteSvg';
import {LogOutSvg} from './LogOutSvg';
import {BasketSvg} from './BasketSvg';
import {BurgerSvg} from './BurgerSvg';
import {MapPinSvg} from './MapPinSvg';
import {ViewAllSvg} from './ViewAllSvg';
import {HomeTabSvg} from './HomeTabSvg';
import {FiltersSvg} from './FiltersSvg';
import {ReadMoreSvg} from './ReadMoreSvg';
import {BigHeartSvg} from './BigHeartSvg';
import {OrderTabSvg} from './OrderTabSvg';
import {CalendarSvg} from './CalendarSvg';
import {ModalMailSvg} from './ModalMailSvg';
import {SortingBySvg} from './SortingBySvg';
import {PhoneCallSvg} from './PhoneCallSvg';
import {InputCheckSvg} from './InputCheckSvg';
import {ProfileTabSvg} from './ProfileTabSvg';
import {SmartPhoneSvg} from './SmartPhoneSvg';
import {RightArrowSvg} from './RightArrowSvg';
import {WishlistBagSvg} from './WishlistBagSvg';
import {CategoryTabSvg} from './CategoryTabSvg';
import {RepeatOrderSvg} from './RepeatOrderSvg';
import {WishlistTabSvg} from './WishlistTabSvg';
import {LeaveAReviewSvg} from './LeaveAReviewSvg';
import {RememberCheckSvg} from './RememberCheckSvg';
import {PromocodeAppliedSvg} from './PromocodeAppliedSvg';

export const svg = {
  BagSvg,
  UserSvg,
  GiftSvg,
  CopySvg,
  MailSvg,
  HeartSvg,
  CheckSvg,
  EyeOffSvg,
  GoBackSvg,
  LogOutSvg,
  BurgerSvg,
  BasketSvg,
  MapPinSvg,
  DeleteSvg,
  SearchSvg,
  ViewAllSvg,
  HomeTabSvg,
  FiltersSvg,
  CalendarSvg,
  OrderTabSvg,
  BigHeartSvg,
  ReadMoreSvg,
  ModalMailSvg,
  SortingBySvg,
  PhoneCallSvg,
  InputCheckSvg,
  RightArrowSvg,
  SmartPhoneSvg,
  ProfileTabSvg,
  CategoryTabSvg,
  RepeatOrderSvg,
  WishlistTabSvg,
  WishlistBagSvg,
  LeaveAReviewSvg,
  RememberCheckSvg,
  PromocodeAppliedSvg,
};
